import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";

export default function DisneyActivation({onContinue}) {
  const {token} = useParams();
  const [tokenInfo, setTokenInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const link = document.querySelector("link[rel~='icon']") || Object.assign(document.createElement('link'), {rel: 'icon'});
    const prevIcon = link.href;
    const prevTitle = document.title;
    link.href = '/nuplin/favicon.ico';
    document.head.appendChild(link);
    document.title = 'Activa tu cuenta de Nuplin';
    return () => {
      link.href = prevIcon;
      document.title = prevTitle;
    };
  }, []);

  useEffect(() => {
    if (token) fetchTokenInfo();
  }, [token]);

  const fetchTokenInfo = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`/api/v1/nuplin/${token}`);
      if (!res.ok) throw new Error(`Error ${res.status}`);
      const data = await res.json();
      setTokenInfo(data);
    } catch (err) {
      setError('No fué posible encontrar el token. Por favor, verifica que el link sea correcto y que no haya caducado.');
    } finally {
      setLoading(false);
    }
  };

  const handleContinue = onContinue || (async () => {
    const res = await fetch(`/api/v1/nuplin/${token}/click`);
    window.location.href = 'https://nuplin.tv/backend2/nuplin/v3/activate?' + tokenInfo?.activationUrl.replace(/https:\/\/.*?activate\?/, "");
  });


  const status = tokenInfo?.status;
  const isCompleted = tokenInfo?.nuplinState === 'COMPLETED';
  const showSteps = status === 'available' || (status === 'used' && !isCompleted);
  const activationDate = tokenInfo?.activationDate
    ? new Date(tokenInfo.activationDate).toLocaleDateString('es-ES', {})
    : null;

  const StatusMessage = ({className = ''}) => {
    if (loading) return <p className={`font-bold text-white text-2xl ${className}`}>Cargando...</p>;
    if (error || status === 'not-found') return <p className={`font-bold text-white text-2xl ${className}`}>Token no encontrado. Verifica que el enlace sea correcto.</p>;
    if (status === 'expired') return <p className={`font-bold text-white text-2xl ${className}`}>Este token ha expirado. Por favor, solicita uno nuevo.</p>;
    if (status === 'error') return <p className={`font-bold text-white text-2xl ${className}`}>Ocurrió un error con este token. Contacta a soporte.</p>;
    if (status === 'used' && isCompleted) return <p className={`font-bold text-black text-2xl ${className}`}>Este token ya fue activado el {activationDate}.</p>;
    return null;
  };

  return (
    <>
      {/* ── DESKTOP ── */}
      <div
        className="hidden md:flex h-screen w-full overflow-hidden"
        style={{
          backgroundImage: 'url(/nuplin/fondo.jpg.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        {/* Columna izquierda */}
        <div className="w-[62%] flex flex-col items-center justify-start py-0 px-[3vw]">
          {showSteps ? (
            <>
              <img src="/nuplin/titulo.png" alt="Activa tu cuenta Nuplin en pasos simples" />
              <div className="flex flex-col gap-[1vh]">
                <img src="/nuplin/1.png" alt="Paso 1" style={{maxHeight: '13vh', width: 'auto', maxWidth: '90%'}} />
                <img src="/nuplin/2.png" alt="Paso 2" style={{maxHeight: '13vh', width: 'auto', maxWidth: '90%'}} />
                <img src="/nuplin/3.png" alt="Paso 3" style={{maxHeight: '13vh', width: 'auto', maxWidth: '90%'}} />
                <img src="/nuplin/4.png" alt="Paso 4" style={{maxHeight: '13vh', width: 'auto', maxWidth: '90%'}} />
              </div>
            </>
          ) : (
            <div className="flex flex-col gap-[1vh] mt-[10vh] text-center">
              <StatusMessage />
            </div>
          )}
        </div>

        {/* Columna derecha */}
        <div className="w-[38%] flex flex-col items-center justify-end py-[3vh] pr-[2vw] gap-4">
          {tokenInfo?.activationUrl && (
            <button
              onClick={handleContinue}
              className="cursor-pointer hover:opacity-90 active:scale-95 transition-all self-end"
              aria-label="Continuar a usar el token"
            >
              <img src="/nuplin/continue.png" alt="Continuar" style={{maxHeight: '8vh', width: 'auto'}} />
            </button>
          )}
        </div>
      </div>

      {/* ── MÓVIL ── */}
      <div
        className="md:hidden min-h-screen flex flex-col items-center px-4 py-6 gap-4"
        style={{
          backgroundImage: 'url(/nuplin/fondo.jpg.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        {showSteps ? (
          <>
            <img src="/nuplin/titulo.png" alt="Activa tu cuenta Nuplin en pasos simples" className="w-full max-w-sm" />
            <img src="/nuplin/puntos.png" alt="Pasos de activación" className="w-full" />
          </>
        ) : (
          <div className="mt-10 text-center">
            <StatusMessage className="text-white" />
          </div>
        )}

        {tokenInfo?.activationUrl && (
          <button
            onClick={handleContinue}
            className="cursor-pointer hover:opacity-90 active:scale-95 transition-all"
            aria-label="Continuar a usar el token"
          >
            <img src="/nuplin/continue.png" alt="Continuar" className="w-52" />
          </button>
        )}
      </div>
    </>
  );
}